import "./footerGtMobile.css";
import { PropsFooterGtMobile } from "../../services/types/linksFooterMobile";

function FooterGtMobile({ setActivePage, activePage }: PropsFooterGtMobile) {
  const linkClass = (page: string) =>
    `flex flex-col items-center ${activePage === page ? "text-blue-600 font-bold" : "text-gray-600"}`;

  return (
    <div id="footer-gt-mobile" className="fixed bottom-16 w-full max-w-screen-sm mx-auto left-0 right-0 bg-white border-t border-gray-200 py-2 z-50">
      <div className="flex justify-around text-xs">
        <button className={linkClass("about")} onClick={() => setActivePage("about")}>
          <span>À propos</span>
        </button>
        <button className={linkClass("faq")} onClick={() => setActivePage("faq")}>
          <span>FAQ</span>
        </button>
        <button className={linkClass("contact")} onClick={() => setActivePage("contact")}>
          <span>Contact</span>
        </button>
        <button className={linkClass("charteGoodDrive")} onClick={() => setActivePage("charteGoodDrive")}>
          <span>Conduite</span>
        </button>
        <button className={linkClass("InfosLegal")} onClick={() => setActivePage("InfosLegal")}>
          <span>Légal</span>
        </button>
        <button className={linkClass("cgu")} onClick={() => setActivePage("cgu")}>
          <span>CGU/V</span>
        </button>
        <button className={linkClass("privacy")} onClick={() => setActivePage("privacy")}>
          <span>Confid.</span>
        </button>
      </div>
    </div>
  );
}

export default FooterGtMobile;